import { render, staticRenderFns } from "./UserMobileNav.vue?vue&type=template&id=38455871&scoped=true&"
import script from "./UserMobileNav.vue?vue&type=script&lang=js&"
export * from "./UserMobileNav.vue?vue&type=script&lang=js&"
import style0 from "./UserMobileNav.vue?vue&type=style&index=0&id=38455871&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38455871",
  null
  
)

export default component.exports